import apiService from '@/services/apiService';

const actions = {
  getExtraPackagings({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/extra-packaging/find-with-paging', payload)
        .then((response) => {
          commit('getExtraPackagings', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getExtraPackagingLogs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/extra-packaging/find-log-with-paging', payload)
        .then((response) => {
          commit('getExtraPackagings', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getExtraPackaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`marketing/extra-packaging/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getExtraPackaging', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  postExtraPackaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/extra-packaging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateExtraPackagings({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/extra-packaging/update-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putExtraPackaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`marketing/extra-packaging/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delExtraPackaging({ commit }, payload) {
    apiService.delete(`marketing/extra-packaging/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
